// Named Export
// Utility

// import Modernizr from "./modernizr";

class Utility {
  constructor() {
    // this.checkSafariMobile();
    // this.checkTouch();
    // this.checkBrowser();
  }

  rafThrottle(callback) {
    this.something = true;
    let requestId = null;

    let lastArgs;

    const later = context => () => {
      requestId = null;
      callback.apply(context, lastArgs);
    };

    const throttled = function (...args) {
      lastArgs = args;
      if (requestId === null) {
        requestId = requestAnimationFrame(later(this));
      }
    };

    throttled.cancel = () => {
      cancelAnimationFrame(requestId);
      requestId = null;
    };

    return throttled;
  }

  debounce(callback, wait, context = this) {
    let timeout = null;
    let callbackArgs = null;
    const later = () => callback.apply(context, callbackArgs);

    return function (...args) {
      callbackArgs = args;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  checkSafariMobile() {
    Modernizr.addTest("mobilesafari", () =>
      /iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(navigator.userAgent)
    );

    this.isSafariMobile = Modernizr.mobilesafari;
  }

  checkTouch() {
    if (Modernizr.touchevents) {
      this.hasTouch = true;
    } else {
      this.hasTouch = false;
    }
  }

  checkBrowser() {
    Modernizr.addTest("ie", () => {
      return (
        /MSIE 10/i.test(navigator.userAgent) ||
        /MSIE 9/i.test(navigator.userAgent) ||
        /rv:11.0/i.test(navigator.userAgent)
      );
    });

    this.isIe = Modernizr.ie;
    // add ie class to <html>
    if (this.isIe) document.documentElement.classList.add("ie");
  }

  // eslint-disable-next-line class-methods-use-this
formatMoney(cents, format = "${{amount_no_trailing_decimals}}", embroideryPricing = "0") {
    if (typeof cents === "string") cents = cents.replace(".", "");
    if (typeof embroideryPricing === "string") embroideryPricing = parseFloat(embroideryPricing) * 100; // Convert dollars to cents
  
    cents = parseInt(cents, 10);
    embroideryPricing = parseInt(embroideryPricing, 10);
  
    // Add embroidery price to the total cents
    let totalCents = cents + embroideryPricing;
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format;
  
    function formatWithDelimiters(number, precision = 2, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";
  
      if (Number.isNaN(number) || number == null) {
        return 0;
      }
  
      number = (number / 100.0).toFixed(precision);
  
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";
  
      return dollarsAmount + centsAmount;
    }
  
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(totalCents, 2);
        break;
      case "amount_full":
        value = formatWithDelimiters(totalCents, 3);
        break;
      case "amount_no_currency":
        value = formatWithDelimiters(totalCents, 2).replace('$', '');
        break;
      case "amount_no_trailing_decimals":
        value = formatWithDelimiters(totalCents, 2).replace(/^([\d,]+)$|^([\d,]+)\.0*$|^([\d,]+\.[0-9]*?)0*$/, "$1$2$3");
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(totalCents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(totalCents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(totalCents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(totalCents, 0, " ");
        break;
      default:
        value = formatWithDelimiters(totalCents, 2);
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  


  isScrolledIntoView(elem, { offsetTop = 0 }) {
    const docViewBottom = window.pageYOffset + window.innerHeight;
    return elem.offsetTop + offsetTop <= docViewBottom;
  }

  static getSiblings(elem) {
    return Array.prototype.filter.call(
      elem.parentNode.children,
      sibling => sibling !== elem
    );
  }

  getParents(element, parentSelector) {
    const result = [];
    while ((element = element.parentElement)) {
      if (element.matches(parentSelector)) {
        result.push(element);
      }
    }
    return result;
  }

  getCookie(key) {
    if (document.cookie.length > 0) {
      let cookieStart = document.cookie.indexOf(key + '=');

      if (cookieStart != -1) {
        cookieStart = cookieStart + key.length + 1;
        let cookieEnd = document.cookie.indexOf(';', cookieStart);

        if (cookieEnd == -1) {
          cookieEnd = document.cookie.length;
        }

        return unescape(document.cookie.substring(cookieStart, cookieEnd));
      }
    }

    return '';
  }

  setShortCookie(name, value, maxAgeSeconds) {
    var maxAgeSegment = "; max-age=" + maxAgeSeconds;
    document.cookie = encodeURI(name) + "=" + encodeURI(value) + maxAgeSegment;
  }

  createCookie(name, value, days) {
    var expires;
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  }

  deleteCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
}

export default Utility;
export const util = new Utility();
